'use es6';

import PortalIdParser from 'PortalIdParser';
import { createClient } from 'laboratory-lib'; // import {
//   /* MON606 */
//   MON606_TREATMENT_KEY,
//   MON606_PARAMETER_KEY,
//   MON606_PARAMETER_OPTIONS,
//   MON606_PUBLIC_TREATMENT_KEY,
// } from 'pricing-pages-unified-ui/constants/ExperimentConstants';

export const inAppTreatmentsClient = createClient({
  ceid: `${PortalIdParser.get()}`,
  quickFetchLabel: 'experiment-early-request',
  timeout: 8000,
  treatments: {// [MON606_TREATMENT_KEY]: {
    //   identifier: `${PortalIdParser.get()}`,
    //   parameters: {
    //     [MON606_PARAMETER_KEY]: Object.values(MON606_PARAMETER_OPTIONS),
    //   },
    // },
  }
});
export const publicTreatmentsClient = createClient({
  quickFetchLabel: 'experiment-early-request',

  /* Don't render-block on the treatments request when
   *  the user starts session without a utk because
   *  it's unlikely that they will grant consent before timeout.
   */
  timeout: window.__HUBSPOT_UTK ? 8000 : 0,
  treatments: {// [MON606_PUBLIC_TREATMENT_KEY]: {
    //   identifier: `${window.__HUBSPOT_UTK}`,
    //   parameters: {
    //     [MON606_PARAMETER_KEY]: Object.values(MON606_PARAMETER_OPTIONS),
    //   },
    // },
    // [MON606_TREATMENT_KEY]: {
    //   identifier: `${window.__HUBSPOT_UTK}`,
    //   parameters: {
    //     [MON606_PARAMETER_KEY]: Object.values(MON606_PARAMETER_OPTIONS),
    //   },
    // },
  }
});
export const resolveInAppTreatments = callback => inAppTreatmentsClient.resolve(callback);
export const resolvePublicTreatments = callback => publicTreatmentsClient.resolve(callback);
export const logInAppExposure = treatmentKey => inAppTreatmentsClient.logExposure(treatmentKey);
export const logPublicExposure = treatmentKey => publicTreatmentsClient.logExposure(treatmentKey);